/**
 * Small confirmation modal (status / fee / password) with simple body content.
 */
export default function MerchantSimpleModal({ open, onClose, title, children, onConfirm, confirmText, confirmTone = 'primary', testid }) {
  if (!open) return null;
  const confirmClass = confirmTone === 'danger' ? 'bg-red-600' : '';
  const confirmStyle = confirmTone === 'danger' ? {} : { backgroundColor: '#003594' };
  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={onClose} data-testid={testid}>
      <div className="bg-white rounded-xl w-full max-w-sm p-6" onClick={(e) => e.stopPropagation()}>
        <h3 className="text-lg font-bold mb-4">{title}</h3>
        {children}
        <div className="flex justify-end gap-2">
          <button onClick={onClose} className="px-4 py-2 text-sm border rounded-lg">Cancelar</button>
          <button onClick={onConfirm} data-testid={testid ? `${testid}-confirm` : undefined} className={`px-4 py-2 text-sm text-white rounded-lg ${confirmClass}`} style={confirmStyle}>
            {confirmText || 'Guardar'}
          </button>
        </div>
      </div>
    </div>
  );
}
